import { useDispatch } from 'react-redux';
import { DesignSystemToken } from 'designSystem/types';
import { toggleDsPick } from 'redux/mode/actions';
import { TokenCard } from './TokenCard';
import * as S from './styles';

interface TokenGridProps {
	tokens: DesignSystemToken[];
}

// Renders a grid of TokenCards with standard click-to-select behavior
const TokenGrid = ({ tokens }: TokenGridProps) => {
	const dispatch = useDispatch();

	return (
		<S.TokenGrid>
			{tokens.map((token) => (
				<TokenCard
					key={token.id}
					token={token}
					onClick={() =>
						dispatch(toggleDsPick({ kind: 'token', cssVariable: token.cssVariable }))
					}
				/>
			))}
		</S.TokenGrid>
	);
};

export default TokenGrid;
